import React, { useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom"; // useNavigate追加
import LoadingOverlay from "../../components/LoadingOverlay";

const ResetPasswordPage: React.FC = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [messages, setMessages] = useState<string[]>([]); // メッセージを配列に
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate(); // useNavigateでログイン戻る
  const query = new URLSearchParams(location.search);
  const token = query.get("token");
  const email = query.get("email");

  const handleResetPassword = async (event: React.FormEvent) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      setMessages(["パスワードが一致しません"]);
      return;
    }

    try {
      setIsLoading(true);

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/reset-password`,
        {
          token,
          email,
          password,
          password_confirmation: confirmPassword,
        }
      );

      setMessages(["パスワードがリセットされました。ログインしてください。"]);
    } catch (error: any) {
      console.error("エラー発生", error);
      if (error.response) {
        console.error("エラー応答", error.response.data);
        // 複数エラーをまとめて取得
        if (error.response.data.errors) {
          const allMessages = Object.values(error.response.data.errors).flat();
          setMessages(allMessages as string[]);
        } else {
          setMessages([
            error.response.data?.message ||
              "エラーが発生しました（サーバ応答）",
          ]);
        }
      } else if (error.request) {
        console.error("リクエスト送信済みだが応答なし", error.request);
        setMessages(["リクエスト送信済みだが応答なし"]);
      } else {
        console.error("その他エラー", error.message);
        setMessages([`エラーが発生しました（${error.message}）`]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 relative">
      {isLoading && <LoadingOverlay />}
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-lg">
        <div className="flex justify-center mb-6">
          <img src="/isopra_icon.png" alt="Logo" className="w-20 h-20" />
        </div>
        <h2 className="text-2xl font-bold text-center text-gray-700 mb-4">
          新しいパスワードの設定
        </h2>
        <form onSubmit={handleResetPassword} className="space-y-4">
          <div>
            <label className="block text-gray-700">新しいパスワード</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="新しいパスワード"
            />
          </div>
          <div>
            <label className="block text-gray-700">
              新しいパスワード（確認）
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="パスワード（確認）"
            />
            <p className="text-sm text-gray-500 text-center">
              ※パスワードは、大文字・小文字・数字・記号を含む10文字以上である必要があります。
            </p>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-500 text-white font-bold py-2 rounded-lg hover:bg-blue-600 transition duration-200"
          >
            パスワードを再設定
          </button>
        </form>

        {/* メッセージ表示 */}
        {messages.length > 0 && (
          <div className="mt-4 text-center text-red-500 whitespace-pre-line">
            {messages.map((msg, index) => (
              <p key={index}>{msg}</p>
            ))}
          </div>
        )}

        {/* 🔸ログイン画面に戻るリンク */}
        <div className="mt-4 text-center">
          <span
            onClick={() => navigate("/login")}
            className="text-blue-500 cursor-pointer hover:underline"
          >
            ログイン画面に戻る
          </span>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
